import classNames from 'classnames';
import { Send2Icon, SmsFilledIcon } from 'icons';
import { useTranslations } from 'next-intl';

interface IProps {
  selected: 'sms' | 'telegram';
  onSelect: (v: 'sms' | 'telegram') => void;
}

export function SmsMethodSelect({ selected, onSelect }: IProps) {
  const t = useTranslations();
  const options = [
    { id: 'sms', label: 'SMS', icon: <SmsFilledIcon /> },
    { id: 'telegram', label: 'Telegram', icon: <Send2Icon /> }
  ] as const;

  return (
    <div className="mt-2 flex items-center gap-2">
      {options.map(opt => (
        <div
          key={opt.id}
          onClick={() => onSelect(opt.id)}
          className={classNames('w-full cursor-pointer rounded-lg pb-1', {
            'bg-black': selected === opt.id,
            'bg-black/25': selected !== opt.id
          })}
        >
          <div
            className={classNames('h-12.5 flex items-center gap-1.5 rounded-lg border bg-white pl-1.5 pr-4', {
              'border-gray-300': selected !== opt.id,
              'border-black': selected === opt.id
            })}
          >
            <div
              className={classNames('size-8.5 flex items-center justify-center', {
                'text-black': selected === opt.id,
                'text-gray-400': selected !== opt.id
              })}
            >
              {opt.icon}
            </div>

            <p className="text-xs">
              {t.rich('kodni_method_orqali_yuborish', {
                method: chunks => <span className="font-semibold">{chunks}</span>,
                label: opt.label
              })}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
